import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { PiCalendarBlank, PiPenNib } from 'react-icons/pi';
import { GoDotFill } from 'react-icons/go';
import { ApiRoutes, Routes } from '@/settings/routes';
import { format, compareAsc } from 'date-fns';

export default function RecentPost({ data }) {
    const image = data?.miniature !== null ? ApiRoutes.ASSETS_ENDPOINT + data?.miniature : 'https://placehold.co/80x80';

    return (
        <div className="flex items-center flex-row gap-4">
            <div className="relative flex items-end group overflow-hidden rounded">
                <img src={image} alt={data.title} className="w-28 h-20 object-cover" />
            </div>
            <div className="relative z-20 w-full">
                <Link prefetch={false} href={`${Routes.FRONT_blog_article + data.slug}`}>
                    <h5 className="text-[1.125rem] font-semibold text-cutom-blue leading[24px] capitalize hover:text-custom-orange-900 transition-colors">{data.title}</h5>
                </Link>
                <div className="flex items-center gap-4 mt-1">
                    <span className="text-gray-400 transition-colors flex items-center gap-2">{format(new Date(data.created_at), 'MMMM dd, yyyy')}</span>
                </div>
            </div>
        </div>
    );
}
